import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { HeatmapShape } from '../shape';
import { MaybeZeroX, MaybeZeroY } from '../transform';
import { baseGeometryChannels, basePostInference, basePreInference, tooltip2d } from './utils';
var shape = {
  heatmap: HeatmapShape
};
/**
 * Draw heatmap with gradient.
 */
export var Heatmap = function Heatmap(options) {
  return function (index, scale, value, coordinate) {
    var X = value.x,
      Y = value.y,
      S = value.size,
      C = value.color;
    var P = Array.from(index, function (i) {
      // Default size = 40.
      var r = S ? +S[i] : 40;
      // Warning: x, y, value, radius.
      return [].concat(_toConsumableArray(coordinate.map([+X[i], +Y[i]])), [C[i], r]);
    });
    return [[0], [P]];
  };
};
Heatmap.props = {
  defaultShape: 'heatmap',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    required: true
  }, {
    name: 'y',
    required: true
  }, {
    name: 'color',
    scale: 'identity',
    required: true
  }, {
    name: 'size'
  }]),
  preInference: [].concat(_toConsumableArray(basePreInference()), [{
    type: MaybeZeroX
  }, {
    type: MaybeZeroY
  }]),
  postInference: [].concat(_toConsumableArray(basePostInference()), _toConsumableArray(tooltip2d()))
};